export default __webpack_public_path__ + "static/media/6.2666ac47.jpg";